import { defineMessages } from '@sm/intl';
import PROJECT_NAME from '~app/pages/Pricing/constants/project';

const COPY = defineMessages({
  ALWAYS_FREE: {
    id: 'Pricing.copy.AlwaysFreeByline',
    defaultMessage: 'Always free',
    desc: {
      id: 'Pricing.copy.AlwaysFreeByline',
      message: '[Type: Text][Vis: high] - Always free byline',
      project: PROJECT_NAME,
    },
  },
  PER_MONTH: {
    id: 'Pricing.copy.PricePerMonthByline',
    defaultMessage: '/ month',
    desc: {
      id: 'Pricing.copy.PricePerMonthByline',
      message: '[Type: Text][Vis: high] - Price per month byline',
      project: PROJECT_NAME,
    },
  },
  PER_USER_PER_MONTH: {
    id: 'Pricing.copy.PricePerUserPerMonthByline',
    defaultMessage: '/ user / month',
    desc: {
      id: 'Pricing.copy.PricePerUserPerMonthByline',
      message: '[Type: Text][Vis: high] - Price per user per month byline',
      project: PROJECT_NAME,
    },
  },
  BILLED_ANNUALLY: {
    id: 'Pricing.copy.PerMonthAnnuallyByline',
    defaultMessage: `{price} billed annually`,
    desc: {
      id: 'Pricing.copy.PerMonthAnnuallyByline',
      message: '[Type: Text][Vis: high] - Price per month billed annually byline',
      project: PROJECT_NAME,
    },
  },
  BILLED_MONTHLY: {
    id: 'Pricing.copy.PerMonthByline',
    defaultMessage: 'Billed monthly',
    desc: '[Type: Text][Vis: high] - Price billed monthly byline',
  },
  TEAMS_BILLED_ANNUALLY: {
    id: 'Pricing.copy.PriceBilledAnnuallyByline',
    defaultMessage: 'Starting at 3 users, billed annually',
    desc: {
      id: 'Pricing.copy.PriceBilledAnnuallyByline',
      message: '[Type: Text][Vis: high] - Price billed annually byline',
      project: PROJECT_NAME,
    },
  },
  // individual country overrides. to override, prefix `BILLED_ANNUALLY` or `TEAMS_BILLED_ANNUALLY` with the country code
  BR_BILLED_ANNUALLY: {
    id: 'Pricing.copy.BrazilBilledAnnually',
    defaultMessage: 'paid annually (up front)',
    desc: {
      id: 'Pricing.copy.BrazilBilledAnnually',
      message: '[Type: Text][Vis: high] - Brazil billed annually byline',
      project: PROJECT_NAME,
    },
  },
  BR_TEAMS_BILLED_ANNUALLY: {
    id: 'Pricing.copy.BrazilTeamsBilledAnnually',
    defaultMessage: 'paid annually for 3 users (up front)',
    desc: {
      id: 'Pricing.copy.BrazilTeamsBilledAnnually',
      message: '[Type: Text][Vis: high] - Brazil teams billed annually byline',
      project: PROJECT_NAME,
    },
  },
  ENT_PLATINUM_BYLINE: {
    id: 'Pricing.copy.EnterpriseByline',
    defaultMessage: 'Powerful admin tools, integrations, and collaboration features for your organization.',
    desc: {
      id: 'Pricing.copy.EnterpriseByline',
      message: '[Type: Text][Vis: high] - Enterprise pricing byline',
      project: PROJECT_NAME,
    },
  },
});

export default COPY;
